import Modulo from './Modulo';

export default Modulo;
